import SVG from 'components/SVG/SVG'
import * as T from 'components/SVG/types'

const UpCaretRounded = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 12 7"
    d="M1.625 1.25L6 5.625L10.375 1.25"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />
)

export default UpCaretRounded
